import { get, post } from '../../../../infra/rest';
import requestConfig from '../../../../shared/config/request';
import { AIFeaturePermissionResponse } from '../typings';

export interface GenerateReplyResponse {
  reply: GenerateReplyTextResponse | null;
}

export interface GenerateReplyTextResponse {
  messageType: 'text';
  text: string;
}

export const generateReply = async ({
  chatId,
  messageIds,
}: {
  chatId: string;
  messageIds: string[];
}): Promise<GenerateReplyResponse> => {
  return post<GenerateReplyResponse>(
    `/v1/chat-bot/generate-reply`,
    {
      body: JSON.stringify({
        chatId,
        messageIds,
      }),
    },
    true
  );
};

export const rephraseTextApi = async ({ text }: { text: string }): Promise<{ rephrasedText: string }> => {
  return post<{ rephrasedText: string }>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/organizations/chat/rephrase`,
    {
      body: JSON.stringify({
        text,
      }),
    },
    true,
    false,
    true
  );
};

export const checkAIFeaturePermissionApi = async (): Promise<AIFeaturePermissionResponse> => {
  return get<AIFeaturePermissionResponse>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/organizations/feature-permissions`,
    undefined,
    true,
    false,
    true
  );
};
